import {useMutation} from '@tanstack/react-query';
import projectUpdaters from '@contentlab/api/project/updaters';

interface UseDeleteProjectOptions {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

function useDeleteProject(options: UseDeleteProjectOptions = {}) {
  const {onSuccess, onError} = options;

  return useMutation<void, Error, string>({
    mutationFn: (projectId: string) => projectUpdaters.deleteProject(projectId),
    onSuccess,
    onError,
  });
}

export default useDeleteProject;
